"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
  query getTrainingProgression($userId: Int!, $from: String!, $to: String!) {
    progressCollection (userId: $userId, range: {from: $from, to: $to}){
      id
      day
      date
      trained
      info {
        doneTrainings
        trainingsInWeek
        weekOrdinalNumber
      }
      trainings {
        day
        rating
        exercises {
          image
          id: exerciseId
          title
          description
          dateTime {
            iso8601
          }
          format
          group
          rating
          repeats
          repsSuffix
          rest
          series
          seriesData {
            parameter {
                name
                options {
                    calculations
                }
            }
            series
            unit
          }
          seriesSuffix
          setsExtended {
            no
            weight
            repetitions
          }
          note {
            body
            previous
          }
          history {
            dateTime { iso8601 }
            sets {
              no
              weight
              repetitions
            }
          }
        }
      } 
    }
  }
`;
//# sourceMappingURL=getTrainingProgressionForDay.js.map